import React, { Component } from "react";
import ReactDOM from 'react-dom';
import axios from "axios";
import days from './days.json'
import months from './months.json'
import weeks from './weeks.json'
import years from './years.json'
import { DOC2SIGN_DOCUMENT_TYPE } from '../constants';
import { CFDI_MASIVO } from '../constants';
import { getErrorsMessage, getSuccessMessage } from '../utils.js';
import DocumentFieldView from "./DocumentFieldView";
import { LangContext } from "../LangContext.jsx";
const fieldTypes = [
    {
        id: 'text',
        title: 'Texto',
        icon: 'fa-font'
    },
    {
        id: 'paragraph',
        title: 'Párrafo',
        icon: 'fa-paragraph'
    },
    {
        id: 'date',
        title: 'Fecha',
        icon: 'fa-calendar'
    },
    {
        id: 'number',
        title: 'Número',
        icon: 'fa-number'
    } 
];
class DocumentView extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        this.state = {
            instructions:'',
            title:'',
            period:'',
            every:1,
            ReferDayName:'Primero',
            monthFrequencyType:'frequency',
            dayOfWeek:1,
            dayOfWeekName:'Lunes',
            monthOfYear:1,
            monthOfYearName:'Enero',
            dayOfMonth:0,
            day:1,
            dayName:'Lunes',
            frequencyType:'once',
            ReferDay:1,
            repeatEvery:1,
            repeatOn:1,
            repeatOnName:'dias',
            cicles:1,
            ends:'never',
            days:days,
            weeks:weeks,
            months:months,
            years:years,
            mimes: [],
            permissions:[],
            cfdis: [],
            selectedMimes: [],
            displayUploadInput:true,
            document: null,
            frequency: null,
            frequency_key: null,
            newFrecuency:'once',
            daysPerPeriod:7,
            frequencies: [
                { key : "once", value : "Único" },
                { key : "weekly", value : "Semanal" },
                { key : "monthly", value : "Mensual" },
                { key : "quarterly", value : "Trimestral" },
                { key : "yearly", value : "Anual" },
            ],
            edit_frequency: true,
            edit_mimes: false,
        };
        this.confirmDelete = this.confirmDelete.bind(this);
        this.delete = this.delete.bind(this);
        this.handleCfdiChange = this.handleCfdiChange.bind(this);
        this.saveFrequency = this.saveFrequency.bind(this)
        this.handleChange = this.handleChange.bind(this)
        this.updateDocument = this.updateDocument.bind(this)
        this.handleFrequencyChange = this.handleFrequencyChange.bind(this)
        this.allowDuplicateAndModification = this.allowDuplicateAndModification.bind(this)
        this.handleInstructionsChange = this.handleInstructionsChange.bind(this)
        this.handleTitleChange = this.handleTitleChange.bind(this)
    }

    async componentDidMount() {
        await this.getDocument()
        await this.getMimes()
        await this.getCfdis()
        this.savePeriod()
        this.state.permissions = this.props.permissions
        var element = document.getElementById('frequency_selector');
        this.state.newFrecuency = element.value
    }

    async getCfdis() {
        const res = await axios.get('/api/cfdis')
        this.setState({cfdis: res.data})
    }

    handleInstructionsChange(e){
        this.setState({
            instructions: e.target.value
        });
    }


    handleTitleChange(e){
        this.setState({ title: e.target.value });
    }

    async getMimes() {
        const res = await axios.get('/api/mimes')
        let mimes; 
        if(this.state.edit_mimes == true){ 
            mimes = res.data.filter(mime => mime.id !== 5);
        } else {
            mimes = res.data;
        }
        this.setState({mimes: mimes})
    }

    async getDocument() {
        const res = await axios.get('/api/documents/' + this.props.document_id)
        this.setState({instructions: res.data.instructions})
        this.setState({title: res.data.title})
        this.setState({document: res.data})
        this.setState({repeatOn: res.data.repeat_on})

        if( res.data.repeat_on== 1){ 
            this.setState({ daysPerPeriod: 7 })
        }
        if( res.data.repeat_on ==2){
            this.setState({ daysPerPeriod: 4 })
        }
        if( res.data.repeat_on == 3){
            this.setState({ daysPerPeriod: 12 })
        }
        if( res.data.repeat_on == 4){
            this.setState({ daysPerPeriod: 2 })
        }


        this.setState({every: res.data.every})
        this.setState({dayOfWeek: res.data.day_of_week})
        this.setState({dayOfMonth: res.data.day_of_month})
        this.setState({monthOfYear: res.data.month_of_year})
        this.setState({ReferDay: res.data.refer_day})
        let monthFrequencyTypeValue;
        res.data.month_frequency_type == 2 ? monthFrequencyTypeValue = 'number': monthFrequencyTypeValue='frequency' ;
        this.setState({monthFrequencyType: monthFrequencyTypeValue})
        this.setState({day: res.data.day})
        this.setState({cicles: res.data.cicles})
        let endValue;
        res.data.ends == 1 ? endValue = 'period': endValue='never' ;
        this.setState({ends: endValue})
        this.setState({frequencyType: res.data.frequency_type})
        var found = this.state.frequencies.filter((row) => { return row.key == res.data.frequency; })[0];
        if(found != undefined){
            this.setState({frequency: found.value})
            this.setState({frequency_key: found.key})
        }

        let editMimes = false;
        if (res.data.mimes[0].id != 5 && res.data.title.includes("Auth") != true) {
            editMimes = true;
        }

        if (res.data.type_id == 2 || res.data.type_id == 3 || res.data.type_id == 5) {
            editMimes = false;
        }

        if(res.data.type_id >= 6 && res.data.type_id <= 15){
            editMimes = false;
        }

        this.setState({edit_mimes: editMimes}, async () => {
            await this.getMimes();
        })
    }

    async handleChange(event){
        this.state.newFrecuency = event.target.value

    }

    async handleFrequencyChange(event){
        this.setState({frequency_key: event.target.value},function(){
            if(event.target.value=='once'){
                this.saveFrequency()
            }
        })
    }

    async handleMimeCheck(e){
        const lang = this.context.lang; 
        this.setState(prevState => {
            let document = Object.assign({}, prevState.document);
            if(e.target.checked == true){
                let mime = this.state.mimes.filter(function( obj ) {
                    return obj.id == e.target.value;
                })
                document.mimes.push(mime[0]);
            }else{
                if(document.mimes.length == 1){
                    Swal.fire({
                        text: lang.get('messages.la_plantilla_de_documento_debe_tener_al_menos_1_tipo_de_formato'),
                        icon: "error",
                        buttonsStyling: false,
                        confirmButtonText: lang.get('messages.aceptar'),
                        customClass: {
                            confirmButton: "btn font-weight-bold btn-primary"
                        }
                    })
                    return false;
                }
                document.mimes = document.mimes.filter(function( obj ) {
                    return obj.id != e.target.value;
                });
            }
            return { document };
        })
    }

    async updateDocument(){
        const { lang } = this.context; 
        window.blockUI(lang.get('messages.procesando'));   
        const params = JSON.stringify({
            mimes: this.state.document.mimes,
            cfdi_id: this.state.document.cfdi_id,
            document_id:this.props.document_id,
        })
        var form = document.getElementById("frm");
        var formData = new FormData(form);
        formData.append('mimes',JSON.stringify(this.state.document.mimes));
        formData.append('cfdi_id',this.state.document.cfdi_id);
       
        formData.append('document_id',this.props.document_id);
        formData.append('title', this.state.title);
        await axios.post(
            '/api/documents/update_mimes',
            formData,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            if($('#template').val() != ''){
                axios.post('/api/documents/template/'+this.props.document_id, formData).then(res=>{})
            }
            window.unblockUI();
            swal.fire({
                text: lang.get('messages.documento_actualizado'),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            })
            this.setState({edit_mimes: false})
            this.getDocument()
            setTimeout(() => {
                window.location = "/documents"
            }, 3000);
        })
    }
    traducirPalabra = (palabra)=>{ 
        const { lang } = this.context;  
        if(palabra == '(es)'){
            return '';
        }
        return lang.get('messages.'+palabra.toLowerCase().replace(/\s+/g, '_').replace(/\s+/g, '_').replace(/[()]/g, '').normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '').replace(/,/g, ''))
    }
    translatePeriod = (texto,document) => {
        
        if (texto === null || texto === undefined) {
            return ''; 
            }
            const palabras = texto.split(/\s+/);
            const textoTraducido = palabras.map((palabra) => this.traducirPalabra(palabra)).join(' ');
            return textoTraducido;
    }
    async saveFrequency(){
        const { lang } = this.context; 
        window.blockUI(lang.get('messages.procesando'));  
        var element = document.getElementById('frequency_selector');
        const params = JSON.stringify({
            frequency: this.state.frequency_key,
            document_id:this.props.document_id,
            every: this.state.every,
            repeat_on: this.state.repeatOn,
            ends: this.state.ends,
            cicles: this.state.cicles,
            day_of_week: this.state.dayOfWeek,
            month_frequency_type: this.state.monthFrequencyType,
            refer_day: this.state.ReferDay,
            day: this.state.day,
            day_of_month: this.state.dayOfMonth,
            month_of_year: this.state.monthOfYear,
            period: this.state.period,
        })
        await axios.post(
            '/api/documents/change_frecuency',
            params,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: lang.get('messages.aceptar'),
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            })
            this.setState({edit_frequency: false})
            this.getDocument()
        })
    }
    handleEveryChange = (e)=>{
        this.setState({ every: e.target.value })
    }
    handleFrequencyPeriodChange = (e)=>{
        if(e.target.value== 1){ 
            this.setState({ daysPerPeriod: 7 })
        }
        if(e.target.value ==2){
            this.setState({ daysPerPeriod: 4 })
        }
        if(e.target.value == 3){
            this.setState({ daysPerPeriod: 12 })
        }
        if(e.target.value == 4){
            this.setState({ daysPerPeriod: 2 })
        }
        this.setState({ repeatOn: e.target.value })
        this.setState({ ReferDay: 1 })
        this.setState({ ReferDayName: 'Primer' })
        this.setState({ day: 1 })
        this.setState({ dayName: 'Lunes' })
    }
    setFrequencyPeriodName = (name)=>{
        let frequencyName = ''
        name == 1 ? frequencyName = 'dia (s)': null;
        name == 2 ? frequencyName ='semana (s)': null;
        name == 3 ? frequencyName ='mes (es)': null;
        name == 4 ? frequencyName ='año (s)': null;
        return frequencyName
    }
    setDayName = (day)=>{
        let name
        day == 1 ? name = "Lunes" : null;
        day == 2 ? name = "Martes" : null;
        day == 3 ? name = "Miercoles" : null;
        day == 4 ? name = "Jueves" : null;
        day == 5 ? name = "Viernes" : null;
        day == 6 ? name = "Sábado" : null;
        day == 7 ? name = "Domingo" : null;
        day == 8 ? name = "Día" : null;
        day == 9 ? name = "Día hábil" : null;
        day == 10 ? name = "Fin de semana" : null;
        return name
    }
    setReferDayName = (referDay) =>{
        let name
        referDay == 1 ? name = "Primero" : null;
        referDay == 2 ? name = "Segundo" : null;
        referDay == 3 ? name = "Tercero" : null;
        referDay == 4 ? name = "Cuarto" : null;
        referDay == 5 ? name = "Quinto" : null;
        referDay == 6 ? name = "Último" : null;
        return name
    }
    setdayOfWeekNameName = (day)=>{
        let name
        day == 1 ? name = "Lunes" : null;
        day == 2 ? name = "Martes" : null;
        day == 3 ? name = "Miercoles" : null;
        day == 4 ? name = "Jueves" : null;
        day == 5 ? name = "Viernes" : null;
        day == 6 ? name = "Sabado" : null;
        day == 7 ? name = "Domingo" : null;
        return name;
    }
    handleDayOfWeekChange = (day)=>{
        this.setState({ dayOfWeek: day })
    }
    setMonthOfYearName = (month)=>{
        month == 1 ? name = "Enero" : null;
        month == 2 ? name = "Febrero" : null;
        month == 3 ? name = "Marzo" : null;
        month == 4 ? name = "Abril" : null;
        month == 5 ? name = "Mayo" : null;
        month == 6 ? name = "Junio" : null;
        month == 7 ? name = "Julio" : null;
        month == 8 ? name = "Agosto" : null;
        month == 9 ? name = "Septiembre" : null;
        month == 10 ? name = "Octubre" : null;
        month == 11 ? name = "Noviembre" : null;
        month == 12 ? name = "Diciembre" : null;
        return name;
    }

    handleMonthOfYearChange = (month)=>{
        this.setState({ monthOfYear: month })
    }

    savePeriod = (post) => {
        let frequencyName = this.setFrequencyPeriodName(this.state.repeatOn)
        let dayOfWeekName = this.setdayOfWeekNameName(this.state.dayOfWeek)
        let ReferDayName = this.setReferDayName(this.state.ReferDay)
        let dayName = this.setDayName(this.state.day)
        let monthOfYearName = this.setMonthOfYearName(this.state.monthOfYear)
        let period = 'Repetir cada ' + this.state.every + ' ' + frequencyName
        let end;
        let periodDescription = ''
        this.state.repeatOn == 2 ? periodDescription = ' el dia ' + dayOfWeekName: null ;
        if( this.state.repeatOn == 3){
            if(this.state.monthFrequencyType == 'number'){
                periodDescription = ' el día ' + this.state.dayOfMonth;
            }
            if(this.state.monthFrequencyType == 'frequency'){
                periodDescription = ' el ' + ReferDayName + ' ' + dayName;
            }
        }
        if( this.state.repeatOn == 4){
                periodDescription = ' el ' + ReferDayName + ' ' + dayName + ' del mes de ' + monthOfYearName;
        }
        period += periodDescription
        this.state.ends == 'never' ? end = 'nunca' : end = 'despues de ' +this.state.cicles + ' repeticiones';
        period += ', termina ' +end
        this.setState({period:period},function(){
            if(post == true){
                this.saveFrequency()
            }
        })
    }
    handleDayOfMonthChange = (day)=>{
        if(this.state.monthFrequencyType == 'number'){
            this.setState({ dayOfMonth: day })
        }
    }
    handleMonthFrequencyType = (e)=>{
        if(e.target.value == 'number'){
            this.setState({ dayOfMonth: 1 })
        }
        if(e.target.value == 'frequency'){
            this.setState({ dayOfMonth: 0 })
        }
        this.setState({ monthFrequencyType: e.target.value })
    }
    handleEndsChange = (e)=>{
        this.setState({ ends: e.target.value })
    }
    handleCicleChange = (e)=>{
        this.setState({ cicles: e.target.value })
        let name
        e.target.value == 1 ? name = "Primero" : null;
        e.target.value == 2 ? name = "Segundo" : null;
        e.target.value == 3 ? name = "Tercero" : null;
        e.target.value == 4 ? name = "Cuarto" : null;
        e.target.value == 5 ? name = "Quinto" : null;
        e.target.value == 6 ? name = "Último" : null;

        this.setState({ cicleName: name })
    }
    handleReferDayChange = (e)=>{
        this.setState({ ReferDay: e.target.value })
    }

    handleDayChange = (e)=>{
        this.setState({ day: e.target.value })
    }

    handleCheck(id,mime){
        let checked = false;
        this.state.document.mimes.map(function(mime){
            if(mime.id == id){
                checked = true
            }
        })

        return checked;
    }

    allowDuplicateAndModification(document) {

        let valid = true;
        if(document.type_id  != 1 ){
            valid = false;
        } 
        return valid;
    }

    confirmDelete() {
        const { lang } = this.context; 
        
        swal.fire({
            text: lang.get('messages.desea_continuar_con_el_borrado'),
            showCancelButton: true,
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: lang.get('messages.continuar'),
            cancelButtonText: lang.get('messages.cancelar'),
            customClass: {
                confirmButton: "btn font-weight-bold btn-danger",
                cancelButton: "btn font-weight-bold btn-secondary"
            }
        }).then((result) => {
            if (result.isConfirmed) {
                this.delete();
            }
        });
    }

    handleCfdiChange(e) {
        this.setState(prevState => ({
            document: {                   // object that we want to update
                ...prevState.document,    // keep all other key-value pairs
                cfdi_id: parseInt(e.target.value)       // update the value of specific key
            }
        }))
    }

    async delete() {
        window.blockUI();

        await axios.delete(
            '/api/documents/' + this.props.document_id,
            {
                "headers": {
                    "content-type": "application/json",
                },
            }
        ).then((response) => {
            window.unblockUI();
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));
            swal.fire({
                text: getSuccessMessage(response),
                icon: "success",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                },
                timer: 3000
            }).then(function(result) {
                window.location.href = '/documents';
            });
        }).catch((error) => {
            window.unblockUI();
            const message = getErrorsMessage(error);
            KTUtil.btnRelease(KTUtil.getById('btnDelete'));

            swal.fire({
                text: message,
                icon: "error",
                buttonsStyling: false,
                confirmButtonText: "Aceptar",
                customClass: {
                    confirmButton: "btn font-weight-bold btn-primary"
                }
            });
        });
    }
    getIconForType(typeId) {
        for (const t of fieldTypes) {
            if (typeId == t.id) {
                return t.icon;
            }
        }
    }
    get isDoc2SignDocument() {
        return this.state.document?.type_id == DOC2SIGN_DOCUMENT_TYPE;
    }

    get isCFDIMasivo() {
        return this.state.document?.type_id == CFDI_MASIVO;
    }

    render() {
        const { isDoc2SignDocument } = this;
        const { lang } = this.context; 
        return (
            <form id="frm" encType="multipart/form-data">
                <div className="modal fade" id="modal"  tabIndex="-1" role="dialog" aria-labelledby="exampleModalSizeSm" arian-hidden="true">
                    <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                        <div className="modal-content text-dark-50   font-size-h5 font-weight-bolder "  >
                            <div className="modal-body px-15 py-10">
                                <h4 className="text-dark font-weight-bold my-1 mr-5">{lang.get('messages.personalizar_frecuencia')}</h4>

                                <div className="row mt-6">
                                    <div className="col-sm-12 d-flex gap-1 align-items-center">
                                        <div>
                                        {lang.get('messages.repetir_cada')}
                                        </div>
                                        <div>
                                        <select value={this.state.every} id="document_system_id" className="form-control form-control-solid bg-white" onChange={this.handleEveryChange}>
                                        {(() => {
                                            let option = [];
                                            for (let i = 1; i <= this.state.daysPerPeriod; i++) {
                                                option.push(<option> {i} </option>);
                                            }
                                            return option;
                                        })()}
                                        </select>
                                        </div>
                                        <div>
                                            <select value={this.state.repeatOn} id="document_system_id" className="form-control form-control-solid bg-white" onChange={this.handleFrequencyPeriodChange}>
                                                <option value={1}>{lang.get('messages.dias')}</option>
                                                <option value={2}>{lang.get('messages.semanas')}</option>
                                                <option value={3}>{lang.get('messages.meses')}</option>
                                                <option value={4}>{lang.get('messages.anos')}</option>
                                            </select>
                                        </div>
                                    </div>
                                    </div>
                                    <div className="row mt-6">
                                    {this.state.repeatOn == 2 &&
                                        <div className="col-sm-6 form-group">
                                        <label className="text-left">{lang.get('messages.repetir_en')}</label>
                                        <div className="d-flex gap-1">
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(1) } } className={ this.state.dayOfWeek == '1'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.lunes')}
                                            </div>
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(2) }} className={ this.state.dayOfWeek == '2'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.martes')}
                                            </div>
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(3) }} className={ this.state.dayOfWeek == '3'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.miercoles')}
                                            </div>
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(4) }} className={ this.state.dayOfWeek == '4'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.jueves')}
                                            </div>
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(5) }} className={ this.state.dayOfWeek == '5'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.viernes')}
                                            </div>
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(6) }} className={ this.state.dayOfWeek == '6'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.sabado')}
                                            </div>
                                            <div onClick={ ()=> { this.handleDayOfWeekChange(7) }} className={ this.state.dayOfWeek == '7'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                            {lang.get('messages.domingo')}
                                            </div>
                                        </div>
                                        </div>
                                    }
                                    {this.state.repeatOn == 3 &&
                                        <div className="col-sm-12 form-group mt-5">
                                            <div className="row d-flex flex-column mt-5">
                                            <div className="col-md-12 gap-1 d-flex align-items-center ">
                                                <div className={ this.state.monthFrequencyType == 'frequency'? '   font-size-h5 selectedRadio'  : '  font-size-h5'}>
                                                    <input type="radio" value="frequency" checked={this.state.monthFrequencyType == 'frequency'} onChange={this.handleMonthFrequencyType}/> El
                                                </div>
                                                <div className=" " >
                                                    <select value={this.state.ReferDay} className="form-control form-control-solid bg-white" onChange={this.handleReferDayChange}>
                                                        <option value={1} selected default>Primero</option>
                                                        <option value={2}>{lang.get('messages.segundo')}</option>
                                                        <option value={3}>{lang.get('messages.tercero')}</option>
                                                        <option value={4}>{lang.get('messages.cuarto')}</option>
                                                        <option value={6}>{lang.get('messages.ultimo')}</option>
                                                    </select>
                                                </div>
                                                <div className=" " >
                                                    <select value={this.state.day} className="form-control form-control-solid bg-white" onChange={this.handleDayChange}>
                                                        <option value={1} selected default>{lang.get('messages.lunes')}</option>
                                                        <option value={2}>{lang.get('messages.martes')}</option>
                                                        <option value={3}>{lang.get('messages.miercoles')}</option>
                                                        <option value={4}>{lang.get('messages.jueves')}</option>
                                                        <option value={5}>{lang.get('messages.viernes')}</option>
                                                        <option value={6}>{lang.get('messages.sabado')}</option>
                                                        <option value={7}>{lang.get('messages.domingo')}</option> 
                                                    </select>
                                                </div>
                                            </div>
                                                <div className="col-md-12 gap-1 d-flex mt-5">
                                                    <div className={ this.state.monthFrequencyType == 'number'? '   font-size-h5 selectedRadio' : '  font-size-h5'}>
                                                        <input type="radio" value="number" checked={this.state.monthFrequencyType == 'number'} onChange={this.handleMonthFrequencyType}/> El día
                                                    </div>
                                                    <div className="d-flex flex-column gap-1" >
                                                    <div className="d-flex gap-1 " >
                                                        {(() => {
                                                            let div = [];
                                                            for (let i = 1; i <= 7; i++) {
                                                                div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                            }
                                                            return div;
                                                        })()}
                                                    </div>
                                                    <div className="d-flex gap-1 " >
                                                        {(() => {
                                                            let div = [];
                                                            for (let i = 8; i <= 14; i++) {
                                                                div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                            }
                                                            return div;
                                                        })()}
                                                    </div>
                                                    <div className="d-flex gap-1 " >
                                                        {(() => {
                                                            let div = [];
                                                            for (let i = 15; i <= 21; i++) {
                                                                div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                            }
                                                            return div;
                                                        })()}
                                                    </div>
                                                    <div className="d-flex gap-1 " >
                                                        {(() => {
                                                            let div = [];
                                                            for (let i = 22; i <= 28; i++) {
                                                                div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                            }
                                                            return div;
                                                        })()}
                                                    </div>
                                                    <div className="d-flex gap-1 " >
                                                        {(() => {
                                                            let div = [];
                                                            for (let i = 29; i <= 31; i++) {
                                                                div.push(<div onClick={ ()=> { this.handleDayOfMonthChange(i) } } className={ this.state.dayOfMonth == i ? 'monthDayOn'  : 'monthDayOff'}> {i} </div>);
                                                            }
                                                            return div;
                                                        })()}
                                                    </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    }
                                    {this.state.repeatOn == 4 &&
                                    <div className="col-sm-12 form-group mt-5">
                                        <div className="row d-flex flex-column mt-5">
                                        <div className="col-md-12 gap-1  ">
                                            El
                                                <div className="d-flex align-items-center">
                                                    <div className=" " >
                                                        <select value={this.state.ReferDay} className="form-control form-control-solid bg-white" onChange={this.handleReferDayChange}>
                                                            <option value={1} selected default>{lang.get('messages.primero')}</option>
                                                            <option value={2}>{lang.get('messages.segundo')}</option>
                                                            <option value={3}>{lang.get('messages.tercero')}</option>
                                                            <option value={4}>{lang.get('messages.cuarto')}</option>
                                                            <option value={6}>{lang.get('messages.ultimo')}</option>
                                                        </select>
                                                    </div>
                                                    <div className=" " >
                                                        <select value={this.state.day} className="form-control form-control-solid bg-white" onChange={this.handleDayChange}>
                                                            <option value={1} selected default>{lang.get('messages.lunes')}</option>
                                                            <option value={2}>{lang.get('messages.martes')}</option>
                                                            <option value={3}>{lang.get('messages.miercoles')}</option>
                                                            <option value={4}>{lang.get('messages.jueves')}</option>
                                                            <option value={5}>{lang.get('messages.viernes')}</option>
                                                            <option value={6}>{lang.get('messages.sabado')}</option>
                                                            <option value={7}>{lang.get('messages.domingo')}</option>
                                                            <option value={8}>{lang.get('messages.dia')}</option>
                                                            <option value={9}>{lang.get('messages.dia_habil')}</option>
                                                            <option value={10}>{lang.get('messages.fin_de_semana')}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                            {lang.get('messages.mes')}
                                                <div className="d-flex gap-1 justify-content-between">
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(1) } } className={ this.state.monthOfYear == '1'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.enero')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(2) } } className={ this.state.monthOfYear == '2'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.febrero')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(3) } } className={ this.state.monthOfYear == '3'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.marzo')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(4) } } className={ this.state.monthOfYear == '4'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.abril')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                                <div className="d-flex gap-1 justify-content-between">
                                                <div onClick={ ()=> { this.handleMonthOfYearChange(5) } } className={ this.state.monthOfYear == '5'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                {lang.get('messages.mayo')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(6) } } className={ this.state.monthOfYear == '6'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.junio')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(7) } } className={ this.state.monthOfYear == '7'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.julio')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(8) } } className={ this.state.monthOfYear == '8'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.agosto')}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-sm-6 form-group">
                                                <div className="d-flex gap-1 justify-content-between">
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(9) } } className={ this.state.monthOfYear == '9'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.septiembre')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(10) } } className={ this.state.monthOfYear == '10'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.octubre')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(11) } } className={ this.state.monthOfYear == '11'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.noviembre')}
                                                    </div>
                                                    <div onClick={ ()=> { this.handleMonthOfYearChange(12) } } className={ this.state.monthOfYear == '12'? '   font-size-h4 dayOn'  : '  font-size-h5 dayOff'}>
                                                    {lang.get('messages.diciembre')}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    }
                                    <div className="col-sm-12 form-group mt-5">
                                    {lang.get('messages.termina')}
                                                <div className="row d-flex flex-column mt-5">
                                                    <div className={ this.state.ends == 'never'? 'col-md-12  font-size-h5 selectedRadio'  : 'col-md-12 font-size-h5'}>
                                                        <input type="radio" value="never" checked={this.state.ends == 'never'} onChange={this.handleEndsChange}/> {lang.get('messages.nunca')}
                                                    </div>
                                                    <div className="col-md-12 gap-1 d-flex align-items-center ">
                                                        <div className={ this.state.ends == 'period'? '   font-size-h5 selectedRadio' : '  font-size-h5'}>
                                                            <input type="radio" value="period" checked={this.state.ends == 'period'} onChange={this.handleEndsChange}/> {lang.get('messages.despues_de')}
                                                        </div>
                                                        <div className=" " >
                                                            <select value={this.state.cicles} className="form-control form-control-solid bg-white" onChange={this.handleCicleChange}>
                                                                <option value={1} selected default>1</option>
                                                                <option value={2}>2</option>
                                                                <option value={3}>3</option>
                                                                <option value={4}>4</option>
                                                                <option value={5}>5</option>
                                                                <option value={6}>6</option>
                                                                <option value={7}>7</option>
                                                                <option value={8}>8</option>
                                                                <option value={9}>9</option>
                                                                <option value={10}>10</option>
                                                                <option value={11}>11</option>
                                                                <option value={12}>12</option>
                                                            </select>
                                                        </div>
                                                        <div className="font-size-h5" >
                                                        {lang.get('messages.repeticiones')}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                    </div>
                                <div className="text-right">
                                    <button type="button" className="btn btn-secondary mr-4" data-dismiss="modal">{lang.get('messages.cancelar')}</button>
                                    <button onClick={ ()=> { this.savePeriod(true) } }  data-dismiss="modal" className="btn btn-primary font-weight-bolder px-10">
                                    {lang.get('messages.guardar')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="subheader py-6 py-lg-8 subheader-transparent" id="kt_subheader">
                    <div className="container d-flex align-items-center justify-content-between flex-wrap flex-sm-nowrap">
                        <div className="d-flex align-items-center flex-wrap mr-1">
                            <div className="d-flex align-items-baseline flex-wrap mr-5">
                                <h5 className="text-dark font-weight-bold my-1 mr-5">
                                    {this.state.document != null ? this.state.document.title : ''}
                                </h5>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="d-flex flex-column-fluid">
                    <div className="container">
                        <div className="row justify-content-center text-left">
                            <div className="col-sm-2 form-group">
                                <div><strong>{ this.state.document!=null ? (this.state.document.required ? lang.get('messages.si') : lang.get('messages.no')) : '' }</strong></div>
                                <div className="text-dark-50">{lang.get('messages.obligatorio')}</div>
                            </div>
                            <div className="col-sm-7 form-group">
                                <label className="text-left">{lang.get('messages.frecuencia')} </label>
                                <div className="d-flex flex-column">
                                    <div className=" d-flex gap-1">
                                        {
                                            this.state.frequency_key == 'once' &&
                                            <>
                                                <div className={ this.state.frequency_key == 'once' ? 'font-size-h4 selectedRadio'  : 'font-size-h5 text-dark'}>
                                                    <input
                                                        type="radio"
                                                        value="once"
                                                        checked={this.state.frequency_key == 'once'}
                                                        disabled={isDoc2SignDocument}
                                                        onChange={this.handleFrequencyChange}
                                                    /> {lang.get('messages.unica')}
                                                </div>
                                                <div className={ this.state.frequency_key == 'yearly' ? 'font-size-h4 selectedRadio' : 'font-size-h5 text-dark'}>
                                                    <input
                                                        data-toggle="modal"
                                                        data-target="#modal"
                                                        type="radio"
                                                        value="yearly"
                                                        checked={this.state.frequency_key == 'yearly'}
                                                        disabled={isDoc2SignDocument}
                                                        onChange={this.handleFrequencyChange}
                                                    /> {lang.get('messages.recurrente')}
                                                </div>
                                            </>
                                        }
                                        {
                                            this.state.frequency_key == 'yearly' &&
                                            <>
                                                <div className="text-dark font-weight-bold">
                                                {lang.get('messages.recurrente')}
                                                </div> 
                                            </>
                                        }  
                                    </div>
                                    <div className="d-flex gap-1">
                                    { (this.state.frequency_key == 'yearly' && this.state.document.document_field_validation_id == null) &&
                                        this.translatePeriod( this.state.period ,this.state.document) 
                                    }
                                    { (this.state.frequency_key == 'yearly' && this.state.document.document_field_validation_id != null) &&
                                        <>{lang.get('messages.personalizada')}</>
                                    } 
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-3 form-group text-right">
                                { (this.state.document != null && !isDoc2SignDocument) &&
                                    <>
                                        { this.allowDuplicateAndModification(this.state.document) &&
                                            <>
                                            
                                                {( this.props.permissions.documents.includes('all') || this.props.permissions.documents.includes('duplicate') ) &&
                                                    <a
                                                        href={"/documents/new?d=" + this.props.document_id}
                                                        className="btn btn-lg btn-success ml-4"
                                                    >
                                                        {lang.get('messages.duplicar_documento')}
                                                    </a>
                                                }
                                            </>
                                        }
                                    </>
                                }
                            </div>
                        </div>
                        <br />
                        <div className="card card-custom gutter-b">
                            <div className="card-body">
                                <div className="text-dark-50 mb-9 float-right">
                                    <strong>{lang.get('messages.fecha_de_creacion')}: { this.state.document!=null ? moment(this.state.document.created_at.split(' ')[0]).format('DD/MM/YYYY') : '' }</strong>
                                </div>
                                <div className="text-dark-50 mb-3 pl-4">
                                    <strong>{lang.get('messages.configuracion_del_documento')}</strong>
                                </div>

                                <div className="mb-2 pl-4">{lang.get('messages.peso_maximo')}: <strong>{ this.state.document!=null ? this.state.document.size : '' }MB</strong></div>
                                <div className="form-group col-8 pl-4"> 
                                    <label className="text-left">{lang.get('messages.nombre')}</label>
                                    <input
                                        id="title"
                                        type="text"
                                        className="form-control form-control-solid"
                                        name="title"
                                        value={this.state.title || ''}
                                        onChange={this.handleTitleChange}
                                    />
                                </div>
                                <div className="d-flex justify-content-between">
                                    <div className="form-group col-8">
                                        <div className="mb-5">{lang.get('messages.formatos')}:
                                            { ( this.props.permissions.documents.includes('all') || this.props.permissions.documents.includes('format') ) &&
                                            <span>
                                                <strong>{ this.state.document!=null ? this.state.document.mimes.map(function(elem){ return elem.title; }).join(", ") : '' }</strong>
                                            </span>
                                            }
                                        </div>
                                        
                                        { (this.state.edit_mimes == true && this.state.document.type_id != 4 && this.state.document.type_id != 2 && this.state.document.type_id != 3 && this.state.document.type_id != 5)  &&
                                            <div className="checkbox-inline">
                                                {this.state.mimes.map((mime) => {
                                                    return(
                                                        <label key={mime.id} className={`checkbox checkbox-lg checkbox-square ${mime.mime != 'pdf' && isDoc2SignDocument ? 'checkbox-disabled' : ''}`}>
                                                            <input
                                                                type="checkbox"
                                                                name="extensions"
                                                                value={mime.id}
                                                                checked={this.handleCheck(mime.id)}
                                                                onChange={ e => (this.handleMimeCheck(e)) }
                                                                disabled={mime.mime != 'pdf' && isDoc2SignDocument}
                                                            />
                                                            <span></span>
                                                            {mime.title}
                                                        </label>
                                                    )
                                                })}
                                            </div>
                                        }
                                    </div>
                                    <div className="form-group col-4">
                                        { this.state.document?.template != null &&
                                            <div className="form-group mt-5">
                                                <div className="text-left">

                                                    <label>{lang.get('messages.'+this.props.update_document_template)}</label>
                                                </div>
                                                {this.state.displayUploadInput == true &&
                                                    <div>
                                                        <input id="template" className="form-control" type="file" onChange={this.ValidateExtension } name="template"/>
                                                    </div>
                                                }
                                                <div className="checkbox-inline mt-4">
                                                    <label className="checkbox checkbox-sm checkbox-square">
                                                        <input type="checkbox" id="delete-template" className="form-control" name="delete_template"/>
                                                        <span></span>
                                                        {lang.get('messages.'+this.props.delete_document_template)}
                                                    </label>
                                                </div>
                                                <div className="text-md-left mt-4 mb-2">
                                                    <a download target="_blank" href={"/documents/" + this.state.document.id + "/template"} className="btn btn-primary btn-sm font-weight-bolder px-5">
                                                        {lang.get('messages.'+this.props.download_document_template)}</a>
                                                </div>
                                            </div>
                                        }
                                        { (this.state.document?.template == null && !isDoc2SignDocument && this.state.document?.type_id != 4) &&
                                            <div className="form-group mt-5">
                                                <div className="text-left"> 
                                                    <label>{lang.get('messages.'+this.props.upload_document_template)}   </label>
                                                </div>
                                                <input id="template" className="form-control" type="file" name="template"/>
                                            </div>
                                        }
                                        
                                    </div>
                                </div>
                                <>
                                </>

                                { this.state.document && !isDoc2SignDocument &&
                                    <div>
                                        <br/>
                                        {lang.get('messages.instrucciones')}
                                        <div className="form-group pl-4">
                                            { !this.isCFDIMasivo &&
                                            <textarea className="form-control" value={this.state.instructions} name="instructions" onChange={this.handleInstructionsChange }></textarea>
                                            }
                                            { this.isCFDIMasivo &&
                                            <div className="instructions-container">
                                                1. {lang.get('messages.descargar_la_plantilla_base_y_llenar_los_datos_requeridos')}.   <br></br>
                                                2. {lang.get('messages.crear_un_archivo_zip_que_contenga_la_plantilla_xls_junto_con_el_numero_de_archivos_xmls_correspondientes_al_rfc_y_periodo_que_se_especifica_en_la_plantilla_base')}. <br></br>
                                                3. {lang.get('messages.asegurarse_que_el_zip_contenga_un_archivo_xls_y_archivos_de_tipo_xml_y_que_estos_sean_diferentes_entre_si')}. <br></br>
                                                4. {lang.get('messages.los_archivos_xml_deberan_ser_de_tipo_de_cfdi_solicitado')}. <br></br>
                                            </div>
                                            } 
                                            </div>
                                        <br/>
                                        <span>{lang.get('messages.informacion_adicional')}</span>
                                        <div className="pl-4">  
                                            {this.state.document?.fields.map((field) => {
                                                return (
                                                <>
                                                    <DocumentFieldView field={field} document={this.state.document} /> 
                                                </>
                                                );
                                            })}
                                        </div>
                                        {this.state.document.type_id > 5 && (
                                            <div className="card mt-6 p-9"> 
                                                <strong className="mb-3">Información a validar para el documento</strong>
                                                <div className="card mt-3 p-9 bg-light-light">
                                                    {this.state.document.description.map((item,index) => {
                                                        return (
                                                            <div key={index} className="mb-2 d-flex align-items-start">
                                                                <span className="mr-2">
                                                                    <i className="fa fa-check icon text-primary font-size-xs"></i>
                                                                </span>
                                                                <span style={{ flex: 1 }}>
                                                                    {item}
                                                                </span>
                                                            </div>
                                                        );
                                                    })}
                                                </div>
                                            </div>
                                        )}
                                        </div>  
                                }
                            </div>
                        </div>

                        <div className="row justify-content-end mt-6">
                            <div className="col-sm-6 text-right">
                                { ( this.props.permissions.documents.includes('all') || this.props.permissions.documents.includes('delete') ) &&
                                <button id="btnDelete" type="button" className="btn btn-lg btn-link text-danger" onClick={this.confirmDelete}>
                                    {lang.get('messages.borrar_documento')}
                                </button>
                                }
                                <a href="/documents" className="btn btn-lg btn-secondary mx-4">
                                {lang.get('messages.cancelar')}
                                </a>
                                <button type="button" onClick={this.updateDocument} className="btn btn-lg btn-primary">
                                {lang.get('messages.guardar')}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
        );
    }
}

export default DocumentView;

if (document.getElementById('DocumentView')) {
    ReactDOM.render(<DocumentView />, document.getElementById('DocumentView'));
}
